/**
 * Price calculation utilities for products with surcharge and discount
 */

/**
 * Get the absolute surcharge value for a product
 * If surcharge_absolute is set, use it directly; otherwise convert percentage surcharge to absolute
 * @param {Object} item - Product item with single_price, surcharge, surcharge_absolute
 * @returns {number} Absolute surcharge value
 */
export function getAbsoluteSurcharge(item) {
    if (Number(item.surcharge_absolute)) {
        return Number(item.surcharge_absolute);
    }
    // Convert percentage surcharge to absolute value
    return Number(item.single_price) * (item.surcharge / 100);
}

/**
 * Calculate the price after applying surcharge (always as absolute value)
 * @param {Object} item - Product item with single_price, surcharge, surcharge_absolute
 * @returns {number} Price after surcharge
 */
export function getPriceAfterSurcharge(item) {
    return Number(item.single_price) + getAbsoluteSurcharge(item);
}

/**
 * Calculate total price for a product line item
 * @param {Object} item - Product item with amount, unit2, discount, and surcharge fields
 * @param {boolean} applyDiscount - Whether to apply discount (default: true)
 * @returns {number} Total price
 */
export function getTotalPrice(item, applyDiscount = true) {
    const priceAfterSurcharge = getPriceAfterSurcharge(item);
    const basePrice = item.unit2 === "TKP"
        ? item.amount / 1000 * priceAfterSurcharge
        : item.amount * priceAfterSurcharge;
    return applyDiscount ? basePrice * (1 - (item.discount / 100)) : basePrice;
}

/**
 * Calculate total prices for an array of products
 * @param {Array} products - Array of product items
 * @returns {number} Sum of all product total prices
 */
export function calculateTotalPrices(products) {
    return products.reduce((acc, item) => acc + getTotalPrice(item), 0);
}
